<template>
  <v-container grid-list-md v-if="isRecurringPaymentEnabled">
    <v-card class="mx-auto" color="white">
      <v-card-text class="px-0">
        <h2 class="font-weight-light pb-3 text-center">Pagamentos Recorrentes</h2>
      </v-card-text>
      <v-list three-line>
        <v-list-tile>
          <v-list-tile-content>
            <v-card-actions class="headline font-weight-bold pa-0">
              <div class="headline font-weight-bold">Gerenciar Assinaturas</div>
              <v-spacer></v-spacer>
              <v-btn
                v-bind:color="color"
                dark
                @click.stop="goToNewSubscription"
              >
                <v-icon left>add</v-icon>
                Novo Pagamento Recorrente
              </v-btn>
            </v-card-actions>
          </v-list-tile-content>
        </v-list-tile>
        
        <v-divider></v-divider>
        <br />
        
        <!-- Tabela integrada ao card -->
        <subscription-table />
      </v-list>
    </v-card>
  </v-container>
  <v-container grid-list-md text-xs-center class="background-billing" v-else>
    <v-layout row wrap class="align-bill">
      <v-card class="mx-auto" max-width="600" style="margin-top: 50px;">
        <v-card-text class="text-center">
          <v-icon size="64" color="grey lighten-1" class="mb-4">block</v-icon>
          <h2 class="headline mb-3">Sistema de Pagamentos Recorrentes Desabilitado</h2>
          <p class="body-1 grey--text text--darken-1">
            Esta funcionalidade não está disponível no momento. 
            Entre em contato com seu representante para mais informações.
          </p>
        </v-card-text>
      </v-card>
    </v-layout>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { EventBus } from '@/services/event-bus';

export default {
  name: 'Subscription',
  created() {
    this.$store.dispatch('invoices/loadList');
    this.$store.dispatch("system/fetchSystemConfiguration").then(() => {
      this.$store.dispatch("account/isRecurringPaymentEnabled");
    });
    this.$store.dispatch("account/getAccount");
  },
  mounted() {
  },
  computed: {
    ...mapGetters({
      invoices: 'invoices/getList',
      color: 'account/color',
      isRecurringPaymentEnabled: "account/isRecurringPaymentEnabled",
    }),
  },
  components: {
    SubscriptionTable: () => import('./SubscriptionsTable.vue'),
  },
  methods: {
    goToNewSubscription() {
      this.$router.push({name: 'new-subscription'})
    }
  },
  data: () => ({
    dialog: false
  })
};
</script>

<style>
  .background-billing {
    background-color: #FFFFFF;
  }
  .align-bill {
    display: block;
    text-align: center;
  }
</style>
